import { computed, defineComponent } from '@vue/composition-api';
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, context) {
        const { root } = context;
        const t = (key) => root.$i18n.t(key);
        // Same behaviour as HomeFooter's intentToSearch: scroll to the hero and
        // put the caret in the search field.
        const intentToSearch = () => {
            const searchInput = document.querySelector('input[type="search"]');
            root.$scrollTo('#hero_search', 1200, { offset: -100 });
            if (searchInput) {
                searchInput.focus();
                searchInput.select();
            }
        };
        return {
            title: computed(() => props.blok?.title || t('home.q4s.cta.title')),
            lead: computed(() => props.blok?.lead || t('home.q4s.cta.lead')),
            intentToSearch
        };
    }
});
